import PaypalPackageButton from "./paypal_package_button.js";
import {PurchaseOtherButton} from "./other_package_button";
import DowngradePackageButton from "./downgrade_package_button.js";
import PurchasedPackageButton from "./purchased_package_button.js";
import NaPackageButton from "./na_package_button.js";
import {generateKey} from "../../../utils/helpers";
import {isAboutExpire30, isSourceApp} from "../helper/helpers";

const renewText = gettext("Renew");
const subscriptionExpiredText = gettext("Your Subscription is Expired");
const addedCartText = gettext("Added to Cart");
const subscribeText = gettext("Subscribe");
const subscribedText = gettext("Subscribed");
const subscribeNowText = gettext("Subscribe now");
const expDateText = gettext("Expiration Date:");
const priceDispExpText = gettext("Price displayed depends on the expiration date");
const upgradeText = gettext("Upgrade");
const manageText = gettext("Manage");
const onlyAvailSuppText = gettext("Only available after expiration or by contacting support.");
const onlyAvailExpText = gettext("Only available after expiration");
const source = catalogModule.getSource();
const CountryPackageButton = (props) => {
    let productPackage = props.productPackage;
    // User has a subscription
    let alreadyBoughtItem = productPackage.hasOwnProperty("expiration_date") && productPackage.status === 'ready'; // check user if it has subscription
    let isCurrentPackage = catalogModule.isUserPkg(productPackage.key);
    let price = parseFloat(productPackage.price).toFixed(2);
    let isWithin30Days = isAboutExpire30(productPackage.expiration_date_ts);
    let packageButtonRender;
    if(catalogModule.isAuthenticated()){
        if(catalogModule.userCanPurchase()){
            if(!catalogModule.hasPackage() && !isCurrentPackage){
                // Check if price is not negative
                if(price > 0){
                    // if subscription is in cart
                    if(catalogModule.isInCart(productPackage.key)) {
                        packageButtonRender = <PurchasedPackageButton textButton={addedCartText}
                                                                      isDisabled={true} />
                    } else {
                        // if subscription is expired
                        if(productPackage.hasOwnProperty('expired') && productPackage.expired === 1){
                            let tempRenewCase1, tempRenewCase2;
                            if(productPackage.status.toLowerCase() !== 'renewing'){
                                tempRenewCase1 = <React.Fragment key={generateKey(productPackage.key)}>
                                    <PaypalPackageButton {...props}
                                                         textButton={renewText}
                                                         messageText={false}/>
                                </React.Fragment>
                            }
                            tempRenewCase2 = <React.Fragment key={Math.random() * 1000}>
                                <div className="message-text">{subscriptionExpiredText}</div>
                            </React.Fragment>;
                            packageButtonRender = [tempRenewCase1, tempRenewCase2];
                        } else {
                            packageButtonRender = <PaypalPackageButton {...props}
                                                                       messageText={true}
                                                                       textButton={subscribeText}/>
                        }
                    }
                } else if(price < 0) {
                    packageButtonRender = <React.Fragment>
                        <PurchaseOtherButton status='upgrade'
                                             noLink={true}
                                             btnStyle={'anp-button purchased full-width'}
                                             key={productPackage.key} />
                        <div className="message-text-info">{onlyAvailSuppText}</div>
                    </React.Fragment>
                }
            } else {
                // If subscription is bought from PayPal
                if(catalogModule.getSource() === 'paypal'){
                    if(alreadyBoughtItem){ // if the user is subscribed to this country
                        if(isWithin30Days){
                            packageButtonRender = <PaypalPackageButton {...props}
                                                                       textButton={renewText}
                                                                       buttonMessage={expDateText + " " + productPackage.expiration_date}
                                                                       messageText={true}/>
                        } else {
                            packageButtonRender = <PurchasedPackageButton textButton={subscribedText}
                                                                          buttonMessage={expDateText + " " + productPackage.expiration_date}
                                                                          isDisabled={true} />
                        }
                    } else if(catalogModule.hasOtherPackage()){ // if the user has a subscription on other countries
                        if(props.isPackage4_12) {
                            if(productPackage.price > 0){
                                if(catalogModule.isInCart(productPackage.key)) {
                                    packageButtonRender =  <PurchasedPackageButton textButton={addedCartText}
                                                                                   isDisabled={true} />
                                } else {
                                    if(props.isUserPackage4_12){
                                        packageButtonRender = <PaypalPackageButton {...props}
                                                                                   messageText={true}
                                                                                   textButton={upgradeText} />
                                    } else {
                                        packageButtonRender = <React.Fragment>
                                            <PurchaseOtherButton status='upgrade'
                                                                noLink={true}
                                                                btnStyle={"anp-button is-primary purchased full-width"}
                                                                key={productPackage.key} />
                                                <div className="message-text-info">{onlyAvailExpText}</div>
                                        </React.Fragment>

                                    }

                                }
                            } else {
                                packageButtonRender = <NaPackageButton {...props} />
                            }
                        } else {
                            packageButtonRender = <PurchasedPackageButton textButton={subscribedText}
                                                                          isDisabled={true} />
                        }
                    } else {
                        // Check the render button
                        if(productPackage.buttonRender === 'upgrade'){
                            if(productPackage.price > 0){
                                if (catalogModule.isInCart(productPackage.key)) {
                                    packageButtonRender =  <PurchasedPackageButton textButton={addedCartText}
                                                                                   isDisabled={true} />
                                } else {
                                    packageButtonRender = <PaypalPackageButton {...props}
                                                                               messageText={true}
                                                                               textButton={upgradeText} />
                                }
                            } else {
                                if(props.isPackage4_12) {
                                    if(productPackage.price > 0){
                                        if(catalogModule.isInCart(productPackage.key)){
                                            packageButtonRender =  <PurchasedPackageButton textButton={addedCartText}
                                                                                           isDisabled={true} />
                                        } else {
                                            packageButtonRender = <PaypalPackageButton {...props}
                                                                                       messageText={true}
                                                                                       textButton={upgradeText} />
                                        }
                                    } else {
                                        packageButtonRender = <NaPackageButton {...props} />
                                    }

                                } else {
                                    // packageButtonRender = <React.Fragment>
                                    //     <button className="anp-button is-dark full-width" onClick={() => sendErrorReport()}>{gettext("Error")}</button>
                                    // </React.Fragment>
                                    packageButtonRender = <NaPackageButton {...props} />
                                }
                            }
                        } else if(productPackage.buttonRender === 'downgrade'){
                            packageButtonRender = <DowngradePackageButton />
                        } else { // fail safe
                            packageButtonRender = <DowngradePackageButton />
                        }
                     }
                } else { // if subscriptions are bought in other platforms e.g. apple
                    //  expiration text - button - expiration text on web
                    let tempContent1, tempContent2, tempContent3;
                    if(productPackage.hasOwnProperty("exp_date") && isCurrentPackage){
                        tempContent1 = <React.Fragment key={generateKey(productPackage.key)}>
                            <div className="message-text">{expDateText + " " + productPackage.exp_date}</div>
                            <div><small>{priceDispExpText}</small></div>
                        </React.Fragment>
                    } else if(productPackage.hasOwnProperty("expiration_date") && isCurrentPackage){
                        tempContent1 = <React.Fragment key={generateKey(productPackage.key)}>
                            <div className="message-text">{expDateText + " " + productPackage.exp_date}</div>
                            <div><small>{priceDispExpText}</small></div>
                        </React.Fragment>
                    }
                    if(price > 0){
                        if(productPackage.buttonRender === 'current'){
                            tempContent2 = <PurchaseOtherButton status='current'
                                                                noLink={catalogModule.getSource() === 'web'}
                                                                btnStyle={"anp-button purchased full-width"}
                                                                key={productPackage.key} />
                        } else if(productPackage.buttonRender === 'upgrade'){
                            // Check current user package if it's 4.12 version
                            let upgradeBtnStyle;
                            if(props.isUserPackage4_12){
                                if(isSourceApp(source)){
                                    upgradeBtnStyle = "anp-button is-primary full-width"
                                } else if(source === "web"){
                                    upgradeBtnStyle = "anp-button purchased full-width"
                                }
                            } else {
                                if(isSourceApp(source)) {
                                    upgradeBtnStyle = "anp-button is-primary full-width"
                                } else {
                                    upgradeBtnStyle = "anp-button purchased full-width";
                                }
                            }
                            tempContent2 = <PurchaseOtherButton status='upgrade'
                                                                noLink={catalogModule.getSource() === 'web' && !props.isUserPackage4_12}
                                                                btnStyle={upgradeBtnStyle}
                                                                key={productPackage.key} />
                        } else if(productPackage.buttonRender === 'downgrade'){
                            tempContent2 = <PurchaseOtherButton status='downgrade'
                                                                noLink={catalogModule.getSource() === 'web'}
                                                                btnStyle={"anp-button purchased full-width"}
                                                                key={productPackage.key} />
                        }
                        // tempContent2 = <a href={manageUrl} target="_blank">
                        //     <button className="anp-button purchased full-width">{manageText}</button>
                        // </a>
                    } else {
                        tempContent2 = <React.Fragment>
                            <PurchaseOtherButton status='upgrade'
                                                 noLink={true}
                                                 btnStyle={'anp-button purchased full-width'}
                                                 key={productPackage.key} />
                            <div className="message-text-info">{onlyAvailSuppText}</div>
                        </React.Fragment>
                    }

                    if(catalogModule.getSource() === 'web') {
                        if(alreadyBoughtItem){
                            tempContent3 = <React.Fragment>
                                <div className="message-text">{expDateText + " " + productPackage.expiration_date}</div>
                            </React.Fragment>
                        } else {
                            tempContent3 = <div className="message-text-info">{onlyAvailSuppText}</div>
                        }
                    }
                    packageButtonRender = [
                        <React.Fragment key={Math.random() * 10}>{tempContent1}</React.Fragment>,
                        <React.Fragment key={Math.random() * 100}>{tempContent2}</React.Fragment>,
                        <React.Fragment key={Math.random() * 1000}>{tempContent3}</React.Fragment>
                    ];
                }
            }
        }
    } else {
        packageButtonRender = <React.Fragment key={generateKey(productPackage.key)}>
            <button onClick={() => selectCountryAnonymous()} className="anp-button is-primary full-width">{subscribeText}</button>
            <div className="message-text"></div>
        </React.Fragment>
    }
    return (
        <React.Fragment key={generateKey(productPackage.key)}>
            {packageButtonRender}
        </React.Fragment>
    );
}

export default CountryPackageButton;
